import { html } from '../lib/html.js';
import { icon } from '../lib/icons.js';
import { hasAnyProgress } from '../lib/store.js';
import { syncState } from '../lib/sync.js';
import { navigate } from '../lib/router.js';
import { dawnScene } from '../components/dawn.js';
import { skyAt } from '../lib/content.js';
import { brandMark } from '../components/chrome.js';

export default async function welcome() {
  if (hasAnyProgress() || syncState().user) return { redirect: '/' };
  return {
    title: 'Welcome',
    focus: true,
    tint: skyAt(0.06 * 0.82),
    html: html`<div class="welcome">
      <div class="welcome__sky">${dawnScene(0.06, { className: 'welcome__dawn' })}</div>
      <div class="welcome__content">
        <div class="welcome__brand">${brandMark(40)}<span class="brand__word">Bhagavad Gita</span></div>
        <h1 class="display welcome__title">Every verse, understood.</h1>
        <p class="welcome__lede">Seven hundred verses. One conversation on a battlefield that has guided people for two thousand years. Learn all of it in short lessons, in plain English, with the original Sanskrit a tap away.</p>
        <ul class="welcome__points">
          <li>${icon('book', { size: 18 })}<span>18 chapters in short lessons of about ten minutes</span></li>
          <li>${icon('languages', { size: 18 })}<span>Every verse in clear, modern English</span></li>
          <li>${icon('idea', { size: 18 })}<span>What it means, why it matters, and a quick check</span></li>
          <li>${icon('cloud', { size: 18 })}<span>Your progress follows you, on any device</span></li>
        </ul>
        <div class="welcome__actions">
          <button type="button" class="btn btn--primary btn--block" data-begin>Begin the journey ${icon('arrow-right', { size: 20 })}</button>
          <a class="btn btn--ghost btn--block" href="/signin?next=%2F">I've been here before · Sign in</a>
        </div>
      </div>
    </div>`,
    mount(root) {
      // Beginning shows how it all works, then asks to sign in (with
      // "Not now"), then opens chapter 1.
      root.querySelector('[data-begin]').addEventListener('click', () => {
        navigate('/guide?start=1');
      });
    },
  };
}
